const orderStatusConfig = {
  NEW: {
    color: '#A99F96'
  },
  IN_PREPARATION: {
    color: '#46C6C6'
  },
  PAID: {
    color: '#FF9450'
  },
  DELIVERED: {
    color: '#64C828'
  },
  CANCELED: {
    color: '#E45A5A'
  }
}

const orderDetailStatusConfig = {
  NEW: {
    color: '#A99F96'
  },
  PURCHASED: {
    color: '#64C828'
  },
  NOT_FOUND: {
    color: '#E45A5A'
  },
  REPLACED: {
    color: '#46C6C6'
  },
  REPLACED_WITH_PROPOSAL: {
    color: '#FF9450'
  },
  PURCHASED_NOT_PERFECT: {
    color: '#9a5ec4'
  }
}

const unknownStatus = {
  color: '#8A3264'
}

export default {
  /**
   * Return color assigned to given status
   *
   * @param {String}
   * @returns {String}
   */
  getColorByOrderStatus: status => orderStatusConfig.hasOwnProperty(status) ? orderStatusConfig[status].color : unknownStatus.color,
  getColorByOrderDetailStatus: status => orderDetailStatusConfig.hasOwnProperty(status) ? orderDetailStatusConfig[status].color : unknownStatus.color
}
